import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/Header.tsx";
import Hero from "./components/Hero.tsx";
import About from "./components/About.tsx";
import Skills from "./components/Skills.tsx";
import Projects from "./components/Projects.tsx";
import Contact from "./components/Contact.tsx";
import Footer from "./components/Footer.tsx";
import LoadingSpinner from "./components/LoadingSpinner.tsx";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simular tiempo de carga y cargar recursos
    const loadApp = async () => {
      try {
        // Simular carga de recursos
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Aquí podrías cargar imágenes, datos, etc.
        // Por ejemplo: await loadImages();

        setIsLoading(false);
      } catch (error) {
        console.error("Error durante la carga:", error);
        setIsLoading(false);
      }
    };

    loadApp();
  }, []);

  return (
    <div className="App">
      <LoadingSpinner isLoading={isLoading} />
      {!isLoading && (
        <>
          <Header />
          <main>
            <Hero />
            <About />
            <Skills />
            <Projects />
            <Contact />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
